import Component from '@component';
import FixScroll from '@utils/html/FixScroll';
import creator from '@utils/creator';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../../colorz/configClrzApp';
import PredictiveSearch from './PredictiveSearch';

export default class Header extends Component {
	onInit(el) {
		this.el = el;
		this.menuPanel = this.el.querySelector('.js-nav-panel');

		this.closePanelBtn = this.el.querySelector('.js-nav-close');
		this.openPanelBtn = this.el.querySelector('.js-nav-open');
		this.mainNav = this.el.querySelector('.js-main-nav');
		this.headerMainLink = this.el.querySelectorAll('.js-header-main-link');

		// User account dropdown
		this.accountDropdown = this.el.querySelector('.js-account-dropdown');
		this.accountToggleBtn = this.el.querySelector('.js-account-toggle');
		this.accountMenu = this.el.querySelector('.js-account-menu');

		this.main = document.querySelector('main');
		this.root = document.documentElement;
		this.announcementBar = document.querySelector('.js-announcement-bar');
		if (this.announcementBar) {
			this.heightAnnouncementBar = this.announcementBar.offsetHeight;
		} else {
			this.heightAnnouncementBar = 0;
		}

		this.headerHeightMobile = this.el.offsetHeight;

		this.isMobile = Device.width < breakpointsApp.desktop;

		if (this.isMobile) {
			this.headerHeight = this.headerHeightMobile;
			this.mainNav.setAttribute('tabindex', -1);
		} else {
			this.headerHeight = this.el.offsetHeight;
		}

		this.root.style.setProperty(
			'--header-height-mobile',
			this.headerHeightMobile + 'px',
		);
		this.root.style.setProperty(
			'--height-announcement-bar',
			this.heightAnnouncementBar + 'px',
		);

		this.isMobile = Device.width < breakpointsApp.desktop;
		this.open = false;

		this.PredictiveSearch = creator('.js-predictive-search', PredictiveSearch);

		this.onScroll = this.onScroll.bind(this);
		this.openPanel = this.openPanel.bind(this);
		this.closePanel = this.closePanel.bind(this);
		this.onDesktopMainNavEscape = this.onDesktopMainNavEscape.bind(this);
	}

	onReady() {
		this.bindEvents();
	}

	initializePanelAccessibility() {
		// Make all focusable elements inside the panel non-tabbable when closed
		if (this.menuPanel) {
			const focusableElements = this.menuPanel.querySelectorAll(
				'summary, a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
			);
			focusableElements.forEach((el) => {
				// Only add tabindex="-1" if the element doesn't already have a specific tabindex
				if (
					!el.hasAttribute('tabindex') ||
					el.getAttribute('tabindex') === '0'
				) {
					el.setAttribute('tabindex', '-1');
					el.dataset.tempTabindex = 'true'; // Mark elements we modified
				}
			});
		}
	}

	bindEvents() {
		this.onResize();
		this.onScroll();

		if (this.isMobile) {
			this.openPanelBtn.removeAttribute('tabindex');
		}

		this.openPanelBtn.addEventListener('click', () => {
			if (this.open == false) {
				this.openPanel();
			} else {
				this.closePanel();
			}
		});

		// Espace/Entrée n'activent pas toujours nativement le click sur ce bouton — on le force explicitement
		this.openPanelBtn.addEventListener('keydown', (e) => {
			if (e.key !== ' ' && e.key !== 'Enter') return;
			e.preventDefault();
			this.openPanelBtn.click();
		});

		document.addEventListener('keydown', this.onDesktopMainNavEscape);

		this.mainNav.addEventListener('mouseleave', () => {
			if (this.mainNav.querySelector('.l-header__main-link.remove-hover')) {
				this.mainNav
					.querySelector('.l-header__main-link.remove-hover')
					.classList.remove('remove-hover');
			}
		});

		this.managedAttributesMenuDesktop();
		this.managedAccountDropdown();
	}

	onResize() {
		this.height = window.innerHeight;
		document.documentElement.style.setProperty('--vh', `${this.height}px`);
	}

	onScroll() {
		if (FixScroll.state || (this.isScrollFixed && !FixScroll.state)) {
			this.isScrollFixed = FixScroll.state;
			return;
		}
		this.stickyHeader();
	}

	openPanel() {
		this.open = true;

		this.menuPanel.classList.add('panel-is-open');
		this.mainNav.setAttribute('aria-expanded', 'true');

		const predictiveSearch = document.querySelector(
			'.js-predictive-search[aria-hidden="false"]',
		);
		if (predictiveSearch) {
			document.querySelector('.js-predictive-search-close').click();
		}

		FixScroll.fix();

		this.menuPanel.setAttribute('aria-hidden', 'false');

		// Auto-open language selector on mobile menu open
		const langSelector = this.menuPanel.querySelector('localization-form');
		if (langSelector) {
			const langBtn = langSelector.querySelector('button');
			const langPanel = langSelector.querySelector('ul');
			if (
				langBtn &&
				langPanel &&
				langBtn.getAttribute('aria-expanded') === 'false'
			) {
				langBtn.setAttribute('aria-expanded', 'true');
				langPanel.removeAttribute('hidden');
			}
		}

		// Restore tabindex for elements that were marked with data-temp-tabindex
		if (this.menuPanel) {
			const focusableElements = this.menuPanel.querySelectorAll(
				'[data-temp-tabindex="true"]',
			);
			focusableElements.forEach((el) => {
				el.removeAttribute('tabindex');
				delete el.dataset.tempTabindex;
			});
		}

		// Focus trap : on intercepte tous les Tab pendant que le menu est ouvert.
		// getVisibleFocusable() est recalculé à chaque appui pour tenir compte
		// des sous-menus <details> ouverts dynamiquement.
		const menuDialog = document.getElementById('menu-mobile') || this.menuPanel;
		menuDialog.setAttribute('tabindex', '-1');

		const menuContent =
			menuDialog.querySelector('[data-menu-content]') || menuDialog;
		const isMenuFocusable = (el) => {
			const detailsAncestors = [];
			let parent = el.parentElement;
			while (parent && menuContent.contains(parent)) {
				if (parent.tagName === 'DETAILS') {
					detailsAncestors.push(parent);
				}
				parent = parent.parentElement;
			}

			for (const details of detailsAncestors) {
				if (!details.open) {
					const summary = details.querySelector(':scope > summary');
					if (el !== summary) return false;
				}
			}
			return true;
		};
		const getVisibleFocusable = () =>
			Array.from(
				menuContent.querySelectorAll(
					'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"])',
				),
			).filter(isMenuFocusable);
		const resolveFocusedElement = (els) => {
			const active = document.activeElement;
			if (!menuContent.contains(active)) return active;

			const summary = active.closest('summary');
			if (summary && els.includes(summary)) return summary;

			return active;
		};

		setTimeout(() => getVisibleFocusable()[0]?.focus(), 50);

		this._menuFocusTrap = (e) => {
			if (e.key !== 'Tab') return;
			const els = getVisibleFocusable();
			if (!els.length) return;
			e.preventDefault();
			const i = els.indexOf(resolveFocusedElement(els));
			els[
				e.shiftKey
					? i <= 0
						? els.length - 1
						: i - 1
					: i >= els.length - 1
					? 0
					: i + 1
			].focus();
		};
		document.addEventListener('keydown', this._menuFocusTrap);

		document.body.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.closePanel();
				this.openPanelBtn.focus();
			}
		});
	}
	closePanel() {
		this.open = false;

		this.menuPanel.classList.remove('panel-is-open');
		document.querySelector('.js-predictive-search-close').click();

		FixScroll.unFix();

		this.menuPanel.setAttribute('aria-hidden', 'true');

		// Remove focus trap
		if (this._menuFocusTrap) {
			document.removeEventListener('keydown', this._menuFocusTrap);
			this._menuFocusTrap = null;
		}
		removeTrapFocus();

		// Reset language selector state
		const langSelector = this.menuPanel.querySelector('localization-form');
		if (langSelector) {
			const langBtn = langSelector.querySelector('button');
			const langPanel = langSelector.querySelector('ul');
			if (langBtn && langPanel) {
				langBtn.setAttribute('aria-expanded', 'false');
				langPanel.setAttribute('hidden', '');
			}
		}

		// Restore tabindex to 0 (so it can be focused again next time it's opened)
		const menu = document.getElementById('menu-mobile') || this.menuPanel;
		if (menu) {
			menu.setAttribute('tabindex', '0');
		}

		// Use the centralized method to make elements non-tabbable
		this.initializePanelAccessibility();

		// Return focus to the burger button
		if (this.openPanelBtn) {
			this.openPanelBtn.focus();
		}
	}
	stickyHeader() {
		const sticky = this.el.offsetTop;

		if (Device.scroll.direction == 'up' && window.pageYOffset > sticky) {
			this.el.classList.add('is-sticky');
			this.root.style.setProperty('--header-margin', this.headerHeight + 'px');

			if (this.isMobile && this.announcementBar) {
				this.announcementBar.classList.add('is-sticky');
			}
		} else {
			this.el.classList.remove('is-sticky');
			this.root.style.setProperty('--header-margin', '0px');

			if (this.isMobile && this.announcementBar) {
				this.announcementBar.classList.remove('is-sticky');
			}
		}
	}

	// Échap : fermer le sous-menu desktop au survol (sans focus dans le lien)
	onDesktopMainNavEscape(e) {
		if (e.key !== 'Escape') return;
		if (Device.width < breakpointsApp.desktop || !this.mainNav) return;

		let openedItems = Array.from(
			this.mainNav.querySelectorAll('.l-header__main-link.is-open'),
		);
		if (!openedItems.length) {
			this.mainNav.querySelectorAll('.l-header__main-link').forEach((link) => {
				const submenu = link.querySelector('.js-menu-list');
				if (!submenu) return;
				const style = window.getComputedStyle(submenu);
				if (style.visibility === 'visible' && parseFloat(style.opacity) > 0) {
					openedItems.push(link);
				}
			});
		}
		if (!openedItems.length) return;

		let toggleToFocus = null;
		for (const item of openedItems) {
			const submenu = item.querySelector('.js-menu-list');
			const toggleBtn = item.querySelector('.js-menu-toggle');
			if (submenu?.contains(document.activeElement) && toggleBtn) {
				toggleToFocus = toggleBtn;
				break;
			}
		}

		e.preventDefault();
		e.stopPropagation();

		openedItems.forEach((item) => {
			const toggleBtn = item.querySelector('.js-menu-toggle');
			item.classList.remove('is-open');
			if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
			this.mainNav.setAttribute('aria-expanded', 'false');
		});

		this.mainNav.querySelectorAll('.l-header__main-link').forEach((el) => {
			el.classList.add('remove-hover');
		});

		if (toggleToFocus) toggleToFocus.focus();
	}

	managedAttributesMenuDesktop() {
		this.headerMainLink.forEach((element) => {
			const submenu = element.querySelector('.js-menu-list');
			const toggleBtn = element.querySelector('.js-menu-toggle');

			// Ouvre le sous-menu au survol
			element.addEventListener('mouseenter', () => {
				if (!submenu) return;
				element.classList.add('is-open');
				if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
			});

			// Ferme au départ de la souris (sauf si utilisateur interagit au clavier)
			element.addEventListener('mouseleave', () => {
				element.classList.remove('is-open');
				if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
			});

			// Clic sur le chevron → toggle manuel (utile au clavier)
			if (toggleBtn) {
				toggleBtn.addEventListener('click', (event) => {
					event.preventDefault();
					const willOpen = !element.classList.contains('is-open');
					element.classList.toggle('is-open', willOpen);
					toggleBtn.setAttribute('aria-expanded', String(willOpen));
				});

				// Gestion de la touche Entrée sur le chevron
				toggleBtn.addEventListener('keydown', (event) => {
					if (event.key === 'Enter') {
						event.preventDefault();
						const willOpen = !element.classList.contains('is-open');
						element.classList.toggle('is-open', willOpen);
						toggleBtn.setAttribute('aria-expanded', String(willOpen));
					}
				});
			}
		});
	}

	managedAccountDropdown() {
		if (!this.accountDropdown || !this.accountToggleBtn || !this.accountMenu) {
			return;
		}

		// Ouvre le dropdown au survol
		this.accountDropdown.addEventListener('mouseenter', () => {
			this.accountDropdown.classList.add('is-open');
			this.accountToggleBtn.setAttribute('aria-expanded', 'true');
		});

		// Ferme au départ de la souris
		this.accountDropdown.addEventListener('mouseleave', () => {
			this.accountDropdown.classList.remove('is-open');
			this.accountToggleBtn.setAttribute('aria-expanded', 'false');
		});

		// Clic sur le chevron → toggle manuel (utile au clavier)
		this.accountToggleBtn.addEventListener('click', (event) => {
			event.preventDefault();
			const willOpen = !this.accountDropdown.classList.contains('is-open');
			this.accountDropdown.classList.toggle('is-open', willOpen);
			this.accountToggleBtn.setAttribute('aria-expanded', String(willOpen));
		});

		// Gestion de la touche Entrée sur le chevron
		this.accountToggleBtn.addEventListener('keydown', (event) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				const willOpen = !this.accountDropdown.classList.contains('is-open');
				this.accountDropdown.classList.toggle('is-open', willOpen);
				this.accountToggleBtn.setAttribute('aria-expanded', String(willOpen));
			}
		});

		// Gestion d'Échap — même si la souris est toujours sur l'élément
		this.accountDropdown.addEventListener('keydown', (e) => {
			if (
				e.key === 'Escape' &&
				this.accountDropdown.classList.contains('is-open')
			) {
				this.accountDropdown.classList.remove('is-open');
				this.accountToggleBtn.setAttribute('aria-expanded', 'false');
				this.accountToggleBtn.focus(); // retour du focus pour accessibilité
			}
		});

		// ACCESSIBILITE Gestion globale de la touche Échap pour fermer le dropdown même quand ouvert via SCSS hover
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				const dropdownContent = this.accountDropdown.querySelector(
					'.l-header_account_dropdown-content',
				);
				if (dropdownContent) {
					// Vérifier si le menu est visible (soit via hover CSS soit via classe is-open)
					const isVisible =
						window.getComputedStyle(dropdownContent).display !== 'none';

					if (isVisible) {
						// Fermeture immédiate avec force-close
						this.accountDropdown.classList.add('force-close');
						this.accountDropdown.classList.remove('is-open');
						this.accountToggleBtn.setAttribute('aria-expanded', 'false');

						// Désactiver le hover temporairement pour éviter la réouverture immédiate
						this.accountDropdown.classList.add('disable-hover');

						// Retirer force-close rapidement mais garder disable-hover plus longtemps
						setTimeout(() => {
							this.accountDropdown.classList.remove('force-close');
						}, 5000);

						// Retirer disable-hover après un délai plus long pour éviter la réouverture immédiate
						setTimeout(() => {
							this.accountDropdown.classList.remove('disable-hover');
						}, 5000);

						// Remettre le focus sur le bouton toggle
						this.accountToggleBtn.focus();

						// Empêcher d'autres gestionnaires d'événements
						e.preventDefault();
						e.stopPropagation();
					}
				}
			}
		});
	}
}
